export function automationOutcome(result = {}) {
  if (result?.deferred && !result?.execution_state) {
    return { message: 'Health refresh queued until the health model update finishes', pending: false };
  }
  switch (result?.execution_state) {
    case 'awaiting_approval':
      return { message: 'Workflow started; some actions await further approval', pending: true };
    case 'scheduled':
      return { message: 'Workflow started; remaining actions are scheduled', pending: true };
    case 'deferred':
      return { message: 'Workflow accepted; execution is deferred', pending: true };
    case 'workflow_active':
      return { message: 'Workflow active; campaign enrollment follows its trigger', pending: false };
    default:
      return null;
  }
}
